import {
  CANCEL_STALL_BOOKING_FAILURE,
  CANCEL_STALL_BOOKING_REQUEST,
  CANCEL_STALL_BOOKING_RESET,
  CANCEL_STALL_BOOKING_SUCCESS,
} from "../../../../redux/types/pvs"

const initialState = {
  loading: false,
  error: false,
  success: false,
  message: "",
}

const cancelStallBookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case CANCEL_STALL_BOOKING_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
        message: "",
      }

    case CANCEL_STALL_BOOKING_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        error: false,
        message: action.payload.message || "Something went wrong",
      }

    case CANCEL_STALL_BOOKING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error || "Something went wrong",
        success: false,
        message: "",
      }

    case CANCEL_STALL_BOOKING_RESET:
      return {
        ...initialState,
      }

    default:
      return state
  }
}

export default cancelStallBookingReducer
